<template>
  <div class="dup__media__call__btn">
    <b-button
      @click="duplicateMediaCall"
      v-b-tooltip.hover
      title="Duplicate"
      class="duplicate-media-call-btn"
      variant="theme"
    >
      <i class="fas fa-copy"></i>
    </b-button>
  </div>
</template>

<script>
export default {
  props: ['deliverableId'],
  methods: {
    duplicateMediaCall() {
      let that = this;
      this.$store.dispatch('duplicateMediaCall', {deliverableId: this.deliverableId}).then(function() {
        that.$store.dispatch('fetchDeliverables').then(function() {
        	that.$store.dispatch('fetchProjectDeliverable').then(function() {
          	that.$store.dispatch('manageUndoActivation', 'Deliverable duplicated.');
          });
        });
        that.$bvModal.hide("editDeliverableModal");
        window.scrollTo(0, 0);
      });
    },
  },
};
</script>

<style>
</style>